/**
 * @description Validate Template Name while createing a Template in CreateTemplateModal
 * @param {string} value
 * @returns {boolean} If the name is valid against the regex params (lowercase, 0-9, spaces and underscore)
 */
export const validateTemplateName = (value) => {
  return /^[a-zA-Z0-9_ ]+$/.test(value);
};

/**
 * @description Validate Template fields for CreateTemplateModal and EditTemplateModal
 * @param {string} action eg. create or edit
 * @param {object} templateData
 * @param {string} templateData.taskName name of the template (for 'create' action)
 * @param {string} templateData.templatePurpose purpose of the template
 * @param {string} templateData.taskMessage message of the task
 * @returns {object} errorData Generated error object with invalid fields (if any) with hasError(boolean),
 * errorMessage(string) and validFields(object)
 */

export function validateTemplateFields(action, templateData) {
  const errorData = {
    hasError: false,
    errorMessage: '',
    validFields: {},
  };

  let { templatePurpose } = templateData;

  const templateName = templateData.templateName || templateData.name;

  // Verify if template name is entered
  if (!templateName || !templateName.trim()) {
    errorData.hasError = true;
    errorData.errorMessage = 'Smart Skill name cannot be empty';
    errorData.validFields.templateNameValid = false;
  }

  // Verify if entered template name is valid
  else if (!validateTemplateName(templateName)) {
    errorData.hasError = true;
    errorData.errorMessage = `Smart Skill's name can contain only alphabetic characters, numbers, 
    underscore and space.`;
    errorData.validFields.templateNameValid = false;
  }

  // Update variables based on the templateData
  if (action === 'edit') {
    templatePurpose = templateData.description;
  }

  // Verify if template purpose is entered
  if (!templatePurpose || !templatePurpose.trim()) {
    errorData.hasError = true;
    errorData.errorMessage = 'Please describe the Smart Skill and its purpose';
    errorData.validFields.templatePurposeValid = false;
  }

  // Show a generic message when there are more than one fields with errors
  if (Object.keys(errorData.validFields).length > 1) {
    errorData.errorMessage = 'Please fill the required fields.';
  }

  return errorData;
}
